module.exports = __webpack_public_path__ + "assets/img/faq.dfa1bd3e.svg";